import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmMap {
    NewLoading:   (pMessage: string) => dmLoading;
    app:          mlBroker;

    GetInAction:  () => boolean;
    SetInAction:  (pInAction: boolean) => void;

    HotelID:      number;
    HotelMapID:   number;
    Filename:     string;
    Verified:     boolean;
    SortOrder:    number;

    Path:         string;

    Description:  string;

    constructor(
         pNewLoading:  (pMessage: string)   => dmLoading
        ,pApp:         mlBroker
        ,pGetInAction: ()                   => boolean
        ,pSetInAction: (pInAction: boolean) => void
        ,pMapEntry:    RQService.Ota.SelectMapsRow
    ) {
        this.NewLoading          = pNewLoading;
        this.app                 = pApp;
        this.GetInAction         = pGetInAction;
        this.SetInAction         = pSetInAction;

        this.HotelID             = pMapEntry.HotelID;
        this.HotelMapID          = pMapEntry.HotelMapID;
        this.Filename            = pMapEntry.Filename;
        this.SortOrder           = pMapEntry.SortOrder;

        this.Path                = encodeURI(
            'https://www.tobook.com/maps/' + this.Filename
        );
                                 
        this.Description         = pMapEntry.Description;
    }

    public SaveDescription(): void {
        if (this.GetInAction()) { return; }

        this.SetInAction(true);

        let loading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            let saveParams = RQParam.OtaEditHotelMapDescriptionParams();
            
            saveParams.HotelID     = this.HotelID;
            saveParams.HotelMapID  = this.HotelMapID;
            saveParams.Description = this.Description.trim();
            
            RQService.Ota.EditHotelMapDescription(saveParams).then((result) => {
                this.Description = this.Description.trim();
            
                loading.Dismiss();
            
                this.SetInAction(false);
            });
        });
    }
}

export class MapsViewModel {
    ShowAlert:             (pTitle: string, pMessage: string)                      => void;
    BackToSignIn:          ()                                                      => void;
    NewLoading:            (pMessage: string)                                      => dmLoading;
    ShowConfirmation:      (pTitle: string ,pMessage: string ,pAction: () => void) => void;

    GetInAction:           ()                                                      => boolean;
    SetInAction:           (pInAction: boolean)                                    => void;

    InAction:              boolean;

    mlText:                MLText;
    app:                   mlBroker;
    ml:                    mlBroker;
    Hotel:                 dmHotel;

    NewMapFileName:        string;
    NewMapDescriptionEN:   string;

    FileSelected:          boolean;

    MapsParams = RQParam.OtaSelectMapsParams();

    Maps:                  dmMap[];

    constructor(
         pMLText:           MLText
        ,pHotel:            dmHotel
        ,pBackToSignIn:     ()                                                        => void
        ,pShowAlert:        (pTitle:   string ,pMessage: string)                      => void
        ,pNewLoading:       (pMessage: string)                                        => dmLoading
        ,pShowConfirmation: (pTitle:   string ,pMessage: string ,pAction: () => void) => void
    ) {
        this.mlText           = pMLText;
        this.app              = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml               = this.mlText.GetBroker(
            'HotelAreaMaps'
        );

        this.Hotel            = pHotel;
        this.BackToSignIn     = pBackToSignIn;
        this.ShowAlert        = pShowAlert;
        this.NewLoading       = pNewLoading;
        this.ShowConfirmation = pShowConfirmation;

        this.InAction         = false;

        this.GetInAction      = () => {
            return this.InAction;
        };

        this.SetInAction  = (pInAction: boolean) => {
            this.InAction = pInAction;
        };

        this.NewMapFileName      = '';
        this.NewMapDescriptionEN = '';
        this.FileSelected        = false;

        this.MapsParams.HotelID  = this.Hotel.HotelID;

        this.Maps                = [];

        this.SetInAction(true);

        this.refreshMaps(() => {
            this.SetInAction(false);
        });
    }

    private refreshMaps(pAction: () => void): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            RQService.Ota.SelectMaps(
                this.MapsParams
            ).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) { return; }
            
                let mapEntries   = response.RQueryResult;
            
                this.Maps.length = 0;
            
                let currentHotelMapID: number = 0;
                let currentMap:        dmMap  = null;
            
                for (let i = 0; i < mapEntries.length; i++) {
                    let mapEntry = RQService.Ota.PopulateSelectMapsRow(
                        mapEntries[i]
                    );
            
                    console.log('row push');
            
                    if (
                        (currentMap        == null)
                    ||  (currentHotelMapID != mapEntry.HotelMapID)
                    ) {
                        currentMap = new dmMap(
                             this.NewLoading
                            ,this.app
                            ,this.GetInAction
                            ,this.SetInAction
                            ,mapEntry
                        );
            
                        this.Maps.push(currentMap);
            
                        currentHotelMapID = currentMap.HotelMapID;
                    }
                }
            
                loading.Dismiss();
            
                pAction();
            });
        });
    }

    public SetFileSelected(event: any) {
        if (event.target.files && event.target.files[0]) { this.FileSelected = true;  }
        else                                             { this.FileSelected = false; }
    }

    public AddMap() {
        if (this.GetInAction()) { return; }

        this.SetInAction(true);

        let loading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            RQService.Extensions.UploadHotelMap(
                 'filepicker'
                ,(this.Hotel.ChainWantsHotelID > 0) ? this.Hotel.HotelID : 0
                ,(result: any) => {
                    let status = RQService.Extensions.PopulateUploadHotelMapRow(result[0]);
            
                    loading.Dismiss();
            
                    if (!status.FileUploadedOK) {
                        let title:   string = this.app.Text(
                             'FileUploadError'
                            ,'File Upload Error'
                        );
                        let message: string = this.app.Text(
                             'ErrorUploadingFile'
                            ,'Error Uploading File'
                        );
            
                        if (status.FileUploadErrorNo == 1) {
                            message = this.app.Text(
                                 'UnrecognisedFileExtension'
                                ,'Unrecognised file extension - must be one of: '
                                  + '.png .jpeg .jpg .gif .tiff .bmp'
                            );
                        }
            
                        if (
                            status.FileUploadErrorNo == 2
                        ||  status.FileUploadErrorNo == 13
                        ) {
                            message = this.app.Text(
                                 'CantSaveFile'
                                ,'Server could not save file - '
                                  + 'contact support@tobook.com for more info'
                            );
                        }
            
                        if (status.FileUploadErrorNo == 11) {
                            message = this.app.Text(
                                 'NoFileSelected'
                                ,'No file selected for upload'
                            );
                        }
            
                        if (status.FileUploadErrorNo == 12) {
                            message = this.app.Text(
                                 'SelectedFileTooLarge'
                                ,'The selected file is too large: max size is 20MB'
                            );
                        }
            
                        this.ShowAlert(title ,message);
            
                        this.SetInAction(false);
            
                        return;
                    }
            
                    let saving = this.NewLoading(
                        this.app.Text('SavingMark' ,'Saving...')
                    );
            
                    saving.Show(() => {
                        this.FileSelected         = false;
                       
                        let editDescriptionParams = RQParam.OtaEditHotelMapDescriptionParams();
                       
                        editDescriptionParams.HotelID     = this.Hotel.HotelID;
                        editDescriptionParams.HotelMapID  = status.FileID;
                        editDescriptionParams.Description = this.NewMapDescriptionEN;
                       
                        RQService.Ota.EditHotelMapDescription(
                            editDescriptionParams
                        ).then((result) => {
                            this.NewMapDescriptionEN = '';
                       
                            saving.Dismiss();
                       
                            this.refreshMaps(() => {
                                this.SetInAction(false);
                            });
                        });
                    });
                }
            );
        });
    }

    public DeleteMap(pHotelMapID: number) {
        if (this.GetInAction()) { return; }

        this.ShowConfirmation(
             this.app.Text(
                 'ConfirmDeleteAction'
                ,'Confirm Delete Action'
            )
            ,this.app.Text(
                 'ConfirmDeleteMap'
                ,'Are you sure you want to delete this map?'
            )
            ,() => {
                if (this.GetInAction()) { return; }

                this.SetInAction(true);

                let loading = this.NewLoading(
                    this.app.Text('DeletingMark' ,'Deleting...')
                );

                loading.Show(() => {
                    let deleteParams = RQParam.OtaDeleteHotelMapParams();
                    
                    deleteParams.HotelID    = this.Hotel.HotelID;
                    deleteParams.HotelMapID = pHotelMapID;
                    
                    RQService.Ota.DeleteHotelMap(deleteParams).then((result) => {
                        loading.Dismiss();
                    
                        this.refreshMaps(() => {
                            this.SetInAction(false);
                        });
                    });
                });
            }
        );
    }

    public NudgeMap(pHotelMapID: number ,pUp: boolean) {
        if (this.GetInAction()) { return; }

        this.SetInAction(true);

        let loading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            let nudgeParams = RQParam.OtaNudgeHotelMapsSortOrderParams();
           
            nudgeParams.HotelID    = this.Hotel.HotelID;
            nudgeParams.HotelMapID = pHotelMapID;
            nudgeParams.Up         = (pUp) ? 1 : 0;
           
            RQService.Ota.NudgeHotelMapsSortOrder(nudgeParams).then((result) => {
                loading.Dismiss();
           
                this.refreshMaps(() => {
                    this.SetInAction(false);
                });
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/maps/xv-maps.ts